import { navigate } from "gatsby";
import { startsWithASingleSlash } from "./startsWithASingleSlash";

export const redirect = async (url: string) => {
  const isInternal = startsWithASingleSlash.test(url);
  if (isInternal) {
    await navigate(url);
  } else {
    window.location.href = url;
  }
};
